<template>
<div>
  <div v-if="this.$route.params.txid">
    <router-view></router-view>
  </div>
  <div v-else>
    <div class="col-12">
      <div class="row">
        <card-component :block="false" title="Listagem Validações" subtitle="" :col="{xs: 12}" @onValidationSelect="validationSelecionouOpcao"
                        :validationSelect="[{id: null,name: 'Últimos cadastros'},{id: 'first',name: 'Mais antigos'}]"
                        @onValidationSelect2="validationSelecionouOpcao2"
                        :validationSelect2="sellers"
                        >
          <validations-list-component :refreshList="validationRefreshList" :orderList="validationOrderList" :seller="validationSeller"></validations-list-component>
        </card-component>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <card-component :block="false" title="Listagem Validações - Aguardando documentação" subtitle="" :col="{xs: 12}" @onValidationSelect="validationSelecionouOpcao"
                        :validationSelect="[{id: null,name: 'Últimos cadastros'},{id: 'first',name: 'Mais antigos'}]"
                         @onValidationSelect2="validationSelecionouOpcao2"
                        :validationSelect2="sellers"
                        >
          <validations-list-component :refreshList="validationRefreshList" :orderList="validationOrderList" :seller="validationSeller" :validations="false"></validations-list-component>
        </card-component>
      </div>
    </div>
    <b-row>
      <b-col>
        <sms-recovery-component v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_SUPER')"></sms-recovery-component>
      </b-col>
    </b-row>
  </div>
</div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import Input from '../../partial/form/Input.vue'
import Button from '../../partial/button/Button.vue'
import ValidationsListNew from '../../partial/validations/ValidatonsListNew.vue'
import SmsRecovery from '../../partial/validations/SmsRecovery.vue'

export default {
  components: {
    'card-component': Card,
    'button-component': Button,
    'input-component': Input,
    'validations-list-component': ValidationsListNew,
    'sms-recovery-component': SmsRecovery
  },
  data () {
    return {
      avatarimage: '',
      appbg: '/static/bgs/2.jpg',
      total: null,
      totalLastDays: null,
      leadPeriod: 7,
      user: {
        name: null,
        age: null,
        email: null,
        id: 'ID R36G48C2'
      },
      datacollection: null,
      datacollectionAccel: null,
      datacollectionDiary: null,
      datacollectionLentDiary: null,
      usersCount: null,
      cpfCount: null,
      cpfPercent: null,
      clickCount: null,
      clickPercent: null,
      clickCpfPercent: null,
      contractCount: null,
      contractPercent: null,
      contractClickPercent: null,
      contractValue: null,

      usersWeekCount: null,
      cpfWeekCount: null,
      cpfWeekPercent: null,
      clickWeekCount: null,
      clickWeekPercent: null,
      clickCpfWeekPercent: null,
      contractWeekCount: null,
      contractWeekPercent: null,
      contractClickWeekPercent: null,
      clickWeekPerCampaign: null,
      lentWeekPerCampaign: null,
      sellers: null,

      linkReport: process.env.API + '/api/users/report?exportFormat=excel&extension=xls'
    }
  },
  methods: {
    setAppBg (image) {
      this.appbg = image
    },
    setAvatarImage (image) {
      this.avatarimage = image
    },
    validationSelecionouOpcao (value) {
      this.$store.dispatch('validationSelecionouOpcao', value)
    },
    validationSelecionouOpcao2 (value) {
      this.$store.dispatch('validationSelecionouOpcao2', value)
    },
    getSellers () {
      this.$http
        .get('api/selects/sellers')
        .then(function (res) {
          console.log(res)
          this.sellers = res.data.list
          this.sellers.splice(0, 0, { id: null, name: 'Selecione o cliente' })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  mounted () {
    this.$http.get('api/me', this.user)
      .then(function (res) {
        console.log(res)
        this.user.name = res.data.firstName
        this.user.age = res.data.age
        this.avatarimage = res.data.pictureProfileUrl
        this.avatarimagelarge = res.data.pictureProfileLargeUrl
      })
      .catch(function (res) {
        console.log('Error')
        console.log(res)
      })
    this.getSellers()
  },
  computed: {
    validationRefreshList () {
      return this.$store.state.validationRefreshList
    },
    validationOrderList () {
      return this.$store.state.validationOrderList
    },
    validationSeller () {
      return this.$store.state.validationSeller
    }
  }
}

</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/card.scss";
</style>



// WEBPACK FOOTER //
// src/components/pages/validations/ValidationListNew.vue